function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, Button, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Popover, Stack, Modal, Typography, useTheme } from '@mui/material';
import React from 'react';
import { AuthorizationAPI } from '../apis';
import { constants, ROUTES } from '../constants';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import SettingsModal from './SettingsModal';
import { clearCache } from '../utils/indexedDBCache';
import HelpCenterIcon from '../../public/HelpCenter.svg';
import ReviewsIcon from '../../public/Reviews.svg';
import SettingsIcon from '../../public/Settings.svg';
import FeedbackModal from './FeedbackModal/FeedbackModal';
import { ConfigContext } from './ConfigContext';
import { useProfilePictureData } from './ProfilePictureContext';
import { PermissionGate } from './PermissionGate';
import { RBAC_ACTIONS } from '@/utils/permissionGateConfig';
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    outline: 0
};
export default function LogoutModal() {
    var _user$userAttributes2, _user$userAttributes4, _user$userAttributes5, _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var _React$useState = React.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _React$useState3 = React.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), settingsOpen = _React$useState4[0], setSettingsOpen = _React$useState4[1];
    var _React$useState5 = React.useState(false), _React$useState6 = _slicedToArray(_React$useState5, 2), feedbackOpen = _React$useState6[0], setFeedbackOpen = _React$useState6[1];
    var _React$useState7 = React.useState(null), _React$useState8 = _slicedToArray(_React$useState7, 2), profilePicture = _React$useState8[0], setProfilePicture = _React$useState8[1];
    var handleOpen = function handleOpen() {
        return setOpen(true);
    };
    var handleClose = function handleClose() {
        return setOpen(false);
    };
    var handleFeedbackOpen = function handleFeedbackOpen() {
        return setFeedbackOpen(true);
    };
    var handleFeedbackClose = function handleFeedbackClose() {
        return setFeedbackOpen(false);
    };
    var navigate = useNavigate();
    var getCachedProfilePicture = useProfilePictureData();
    var _React$useState9 = React.useState(null), _React$useState0 = _slicedToArray(_React$useState9, 2), anchorElLogout = _React$useState0[0], setAnchorElLogout = _React$useState0[1];
    var theme = useTheme();
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var _React$useState1 = React.useState(function () {
        try {
            var _Cookies$get;
            return JSON.parse((_Cookies$get = Cookies.get('user')) !== null && _Cookies$get !== void 0 ? _Cookies$get : '{}');
        }
        catch (_unused) {
            return {};
        }
    }), _React$useState10 = _slicedToArray(_React$useState1, 2), user = _React$useState10[0], setUser = _React$useState10[1];
    var _React$useState11 = React.useState('50%'), _React$useState12 = _slicedToArray(_React$useState11, 2), tipPosition = _React$useState12[0], setTipPosition = _React$useState12[1];
    var popoverOpen = Boolean(anchorElLogout);
    var _React$useState13 = React.useState(user), _React$useState14 = _slicedToArray(_React$useState13, 2), settingsInitialUser = _React$useState14[0], setSettingsInitialUser = _React$useState14[1];
    React.useEffect(function () {
        if (popoverOpen && anchorElLogout) {
            requestAnimationFrame(function () {
                setTimeout(function () {
                    var anchorRect = anchorElLogout.getBoundingClientRect();
                    var popoverElement = document.querySelector('.MuiPopover-root .MuiPaper-root');
                    if (popoverElement) {
                        var popoverRect = popoverElement.getBoundingClientRect();
                        var anchorCenter = anchorRect.left + anchorRect.width / 2;
                        var popoverLeft = popoverRect.left;
                        var relativePosition = anchorCenter - popoverLeft;
                        var percentage = relativePosition / popoverRect.width * 100;
                        var clampedPercentage = Math.max(10, Math.min(90, percentage));
                        setTipPosition("".concat(clampedPercentage, "%"));
                    }
                }, 150);
            });
        }
    }, [popoverOpen, anchorElLogout]);
    React.useEffect(function () {
        if (popoverOpen) {
            globalThis.dispatchEvent(new Event('profileModalOpen'));
        }
        else {
            globalThis.dispatchEvent(new Event('profileModalClose'));
        }
    }, [popoverOpen]);
    var handleProfileMenuOpen = function handleProfileMenuOpen(event) {
        setAnchorElLogout(event.currentTarget);
    };
    var handleCloseLogout = function handleCloseLogout() {
        setAnchorElLogout(null);
    };
    var handleSettingsOpen = function handleSettingsOpen() {
        setSettingsInitialUser(user);
        setSettingsOpen(true);
    };
    var handleSettingsClose = function handleSettingsClose() {
        return setSettingsOpen(false);
    };
    var logout = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return AuthorizationAPI.logout().then(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                                var _t;
                                return _regenerator().w(function (_context) {
                                    while (1)
                                        switch (_context.p = _context.n) {
                                            case 0:
                                                _context.p = 0;
                                                _context.n = 1;
                                                return clearCache();
                                            case 1:
                                                _context.n = 3;
                                                break;
                                            case 2:
                                                _context.p = 2;
                                                _t = _context.v;
                                                console.error('Failed to clear IndexedDB cache on logout:', _t);
                                            case 3:
                                                // Clear cookies and session storage
                                                sessionStorage.clear();
                                                Cookies.remove('access_token');
                                                Cookies.remove('refresh_token');
                                                Cookies.remove('user');
                                                Cookies.remove('ui_trace_id');
                                                Cookies.remove('theme');
                                                sessionStorage.clear();
                                                navigate('/');
                                                handleClose();
                                            case 4:
                                                return _context.a(2);
                                        }
                                }, _callee, null, [[0, 2]]);
                            })));
                        case 1:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function logout() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSettingsSave = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(settings, updatedUser) {
            var _Cookies$get2, parsed;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            if (updatedUser) {
                                setUser(updatedUser);
                            }
                            else {
                                // Fallback: attempt to refresh from cookie if update failed
                                try {
                                    parsed = JSON.parse((_Cookies$get2 = Cookies.get('user')) !== null && _Cookies$get2 !== void 0 ? _Cookies$get2 : '{}');
                                    setUser(parsed);
                                }
                                catch (_unused2) {
                                    // Silently handle parse failure
                                }
                            }
                            handleSettingsClose();
                        case 1:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function handleSettingsSave(_x, _x2) {
            return _ref3.apply(this, arguments);
        };
    }();
    React.useEffect(function () {
        var _user$userAttributes;
        var userEmail = user === null || user === void 0 || (_user$userAttributes = user.userAttributes) === null || _user$userAttributes === void 0 || (_user$userAttributes = _user$userAttributes.email) === null || _user$userAttributes === void 0 ? void 0 : _user$userAttributes.trim();
        if (!userEmail) {
            setProfilePicture(null);
            return;
        }
        var fetchProfilePicture = /*#__PURE__*/ function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
                var profilePictureResponse, _t2;
                return _regenerator().w(function (_context4) {
                    while (1)
                        switch (_context4.p = _context4.n) {
                            case 0:
                                _context4.p = 0;
                                _context4.n = 1;
                                return getCachedProfilePicture();
                            case 1:
                                profilePictureResponse = _context4.v;
                                setProfilePicture(profilePictureResponse);
                                _context4.n = 3;
                                break;
                            case 2:
                                _context4.p = 2;
                                _t2 = _context4.v;
                                setProfilePicture(null);
                            case 3:
                                return _context4.a(2);
                        }
                }, _callee4, null, [[0, 2]]);
            }));
            return function fetchProfilePicture() {
                return _ref4.apply(this, arguments);
            };
        }();
        fetchProfilePicture();
    }, [user === null || user === void 0 || (_user$userAttributes2 = user.userAttributes) === null || _user$userAttributes2 === void 0 ? void 0 : _user$userAttributes2.email, getCachedProfilePicture]);
    var getInitialsFromCommaFormat = function getInitialsFromCommaFormat(name) {
        var _parts$0$2;
        var parts = name === null || name === void 0 ? void 0 : name.split(',').map(function (part) {
            return part.trim();
        }).filter(Boolean);
        if (!parts || parts.length === 0) {
            return '';
        }
        if (parts.length > 1 && parts[0] && parts[1]) {
            var _parts$1$, _parts$0$;
            var first = ((_parts$1$ = parts[1][0]) === null || _parts$1$ === void 0 ? void 0 : _parts$1$.toUpperCase()) || '';
            var second = ((_parts$0$ = parts[0][0]) === null || _parts$0$ === void 0 ? void 0 : _parts$0$.toUpperCase()) || '';
            return "".concat(first).concat(second);
        }
        return ((_parts$0$2 = parts[0][0]) === null || _parts$0$2 === void 0 ? void 0 : _parts$0$2.toUpperCase()) || '';
    };
    var getInitialsFromSpaceFormat = function getInitialsFromSpaceFormat(name) {
        var parts = name === null || name === void 0 ? void 0 : name.split(' ').filter(function (part) {
            return part.length > 0;
        });
        if (!parts || parts.length === 0) {
            return '';
        }
        if (parts.length >= 2) {
            var _parts$at$0$toUpperCa, _parts$at;
            return "".concat(parts[0][0].toUpperCase()).concat((_parts$at$0$toUpperCa = (_parts$at = parts.at(-1)) === null || _parts$at === void 0 ? void 0 : _parts$at[0].toUpperCase()) !== null && _parts$at$0$toUpperCa !== void 0 ? _parts$at$0$toUpperCa : '');
        }
        return parts[0][0].toUpperCase();
    };
    var getInitials = function getInitials() {
        var _user$userAttributes3, _name$0$toUpperCase;
        var name = user === null || user === void 0 || (_user$userAttributes3 = user.userAttributes) === null || _user$userAttributes3 === void 0 || (_user$userAttributes3 = _user$userAttributes3.name) === null || _user$userAttributes3 === void 0 ? void 0 : _user$userAttributes3.trim();
        if (!name) {
            var _user$username$0$toUp, _user$username;
            return (_user$username$0$toUp = user === null || user === void 0 || (_user$username = user.username) === null || _user$username === void 0 || (_user$username = _user$username[0]) === null || _user$username === void 0 ? void 0 : _user$username.toUpperCase()) !== null && _user$username$0$toUp !== void 0 ? _user$username$0$toUp : '';
        }
        if (name.includes('@'))
            return (_name$0$toUpperCase = name[0].toUpperCase()) !== null && _name$0$toUpperCase !== void 0 ? _name$0$toUpperCase : '';
        if (name.includes(','))
            return getInitialsFromCommaFormat(name);
        if (name.includes(' '))
            return getInitialsFromSpaceFormat(name);
        return name[0].toUpperCase();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        "aria-label": "account of current user",
        "aria-haspopup": "true",
        onClick: handleProfileMenuOpen,
        "data-testid": "logout-details",
        sx: {
            p: 0,
            mr: -0.5,
            backgroundColor: '#EBEBEB',
            borderRadius: '50%',
            minWidth: '32px',
            minHeight: '32px',
            width: '32px',
            height: '32px',
            color: '#595959'
        },
        variant: "text"
    }, /*#__PURE__*/ React.createElement(Avatar, {
        src: profilePicture !== null && profilePicture !== void 0 ? profilePicture : undefined,
        imgProps: {
            onError: function onError() {
                return setProfilePicture(null);
            }
        },
        sx: {
            bgcolor: '#e0e0e0',
            color: '#424242',
            fontWeight: 600,
            fontStyle: 'SemiBold',
            lineHeight: '152%',
            letterSpacing: '0.17px',
            fontSize: '14px',
            fontFamily: theme.typography.fontFamily,
            width: 32,
            height: 32
        }
    }, getInitials())), /*#__PURE__*/ React.createElement(Popover, {
        open: Boolean(anchorElLogout),
        anchorEl: anchorElLogout,
        onClose: handleCloseLogout,
        disableRestoreFocus: true,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        slotProps: {
            paper: {
                style: {
                    borderRadius: '16px',
                    overflow: 'visible',
                    marginTop: '25px'
                },
                sx: {
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: -9,
                        left: tipPosition,
                        transform: 'translateX(-50%)',
                        width: 14,
                        height: 10,
                        background: 'transparent',
                        zIndex: 2,
                        pointerEvents: 'none',
                        WebkitClipPath: 'polygon(46% 0%, 54% 0%, 100% 100%, 0% 100%)',
                        clipPath: 'path("M0 100% L46% 10% Q50% 0% 54% 10% L100% 100% Z")',
                        backgroundColor: '#fff',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                    }
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(List, {
        sx: {
            width: '300px',
            bgcolor: 'background.paper',
            borderRadius: '16px'
        }
    }, /*#__PURE__*/ React.createElement(ListItem, null, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        alignItems: "center",
        gap: 2
    }, /*#__PURE__*/ React.createElement(Avatar, {
        src: profilePicture !== null && profilePicture !== void 0 ? profilePicture : undefined,
        imgProps: {
            onError: function onError() {
                return setProfilePicture(null);
            }
        },
        sx: {
            bgcolor: '#e0e0e0',
            color: '#424242',
            fontWeight: 600,
            fontStyle: 'SemiBold',
            lineHeight: '152%',
            letterSpacing: '0.17px',
            fontSize: '14px',
            fontFamily: theme.typography.fontFamily
        }
    }, getInitials()), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        fontWeight: "400",
        color: "#212121"
    }, user === null || user === void 0 || (_user$userAttributes4 = user.userAttributes) === null || _user$userAttributes4 === void 0 ? void 0 : _user$userAttributes4.name), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        color: "#595959",
        fontWeight: 400
    }, user === null || user === void 0 || (_user$userAttributes5 = user.userAttributes) === null || _user$userAttributes5 === void 0 ? void 0 : _user$userAttributes5.email)))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 1
        }
    }), /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_VIEW_APPLICATION]
    }, /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        onClick: function onClick() {
            window.open(ROUTES.HELP, '_blank');
            handleCloseLogout();
        }
    }, /*#__PURE__*/ React.createElement(ListItemButton, null, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 36
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: HelpCenterIcon,
        alt: "HelpCenter",
        style: {
            width: 24,
            height: 24
        }
    })), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: constants.help_center_title
    })))), /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_UPDATE_FEEDBACK]
    }, /*#__PURE__*/ React.createElement(ListItemButton, {
        onClick: function onClick() {
            handleFeedbackOpen();
            handleCloseLogout();
        }
    }, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 36
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: ReviewsIcon,
        alt: "Reviews",
        style: {
            width: 24,
            height: 24
        }
    })), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: constants.feedback
    }))), /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_VIEW_USER]
    }, /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        onClick: function onClick() {
            handleCloseLogout();
            handleSettingsOpen();
        },
        "data-testid": "settings-item-user"
    }, /*#__PURE__*/ React.createElement(ListItemButton, null, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 36
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: SettingsIcon,
        alt: "Settings",
        style: {
            width: 24,
            height: 24
        }
    })), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: constants.settings_title
    })))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 1
        }
    }), /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        onClick: function onClick() {
            handleOpen();
            handleCloseLogout();
        },
        "data-testid": "logout-item"
    }, /*#__PURE__*/ React.createElement(ListItemButton, null, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 36
        }
    }, /*#__PURE__*/ React.createElement(LogoutIcon, null)), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: constants.logout
    }))))), /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description"
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: style
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "modal-modal-title",
        variant: "body1"
    }, constants.exit_msg), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 2,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        onClick: handleClose,
        "data-testid": "logout-cancel",
        sx: {
            borderColor: configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color,
            color: configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color,
            '&:hover': {
                borderColor: configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        onClick: function onClick() {
            logout();
        },
        "data-testid": "logout-logout",
        sx: {
            bgcolor: configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.button_color
        }
    }, constants.logout)))), /*#__PURE__*/ React.createElement(FeedbackModal, {
        open: feedbackOpen,
        onClose: handleFeedbackClose
    }), /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_UPDATE_USER],
        behavior: "grey"
    }, /*#__PURE__*/ React.createElement(SettingsModal, {
        open: settingsOpen,
        onClose: handleSettingsClose,
        onUpdate: handleSettingsSave,
        initialUser: settingsInitialUser
    })));
}
